<output id="loading-overlay" *ngIf="visible" [class.loading-overlay--visible]="fadeIn" data-cy="LoadingScreen_Overlay" aria-live="assertive" tabindex="-1" #overlay>
  <spinner></spinner>
  <p *ngIf="messageKey" class="loading-message">{{ messageKey | translate }}</p>
</output>
